import { fetchClient } from '@/lib/api';
import { getKeyFromSelector } from '@/lib/i18n';
import { redirect, type ParsedLocation } from '@tanstack/react-router';
import { parametrosTesteGratisSchema } from './-schemas';

function getApiErrorMessageKey(status: number) {
  if (status === 404) {
    return getKeyFromSelector($ => $.testeGratis.erros.revendaNaoEncontrada, {
      ns: 'public',
    });
  }

  return getKeyFromSelector($ => $.unexpectedError);
}

export async function testeGratisLoader({
  location,
}: {
  location: ParsedLocation;
}) {
  // Não usamos `validateSearch` pois o router mudaria a chave dos valores na url
  // Ex.: ?r=123&d=15 -> ?revendaId=123&duracaoEmDias=15
  const result = parametrosTesteGratisSchema.safeParse(location.search);

  if (!result.success) {
    const key = result.error.issues[0]?.message;

    throw redirect({
      to: '/novo-cliente/erro',
      search: { messageKey: key },
      mask: { to: '/novo-cliente' },
    });
  }

  const { response, data } = await fetchClient.GET(
    '/revendas/{revendaId}/teste-gratis',
    { params: { path: { revendaId: result.data.revendaId } } },
  );

  if (response.ok && data?.podeCadastrar) {
    return;
  }

  const key = !response.ok
    ? getApiErrorMessageKey(response.status)
    : getKeyFromSelector($ => $.testeGratis.erros.revendaNaoEncontrada, {
        ns: 'public',
      });

  throw redirect({
    to: '/novo-cliente/erro',
    search: { messageKey: key },
    mask: { to: '/novo-cliente' },
  });
}
